export default {
  name: 'Information',
  data() {
    return {
      // Список категорий
      categories: [],
      // Список продуктов за категорию и группу
      products: [],
      // Идентификатор таймаута (для поиска)
      timeoutId: null,
      // Поисковая строка
      searchValue: '',
      submenuBtn: false,
    };
  },
  computed: {
    submenu() { return this.$store.state.submenu; },
  },
  watch: {
    searchValue(newValue) {
      clearTimeout(this.timeoutId);
      if (!newValue) {
        this.products = [];
        return;
      }
      this.timeoutId = setTimeout(() => {
        this.$store.getters.axl
          .post('/docs/api/doc/search', {
            search: newValue,
          })
          .then((response) => {
            this.products = response.data.items;
          });
      }, 300);
    },
  },
  methods: {
    /**
     * Обработчик клика по группе
     * @param categoryId идентификатор категории
     * @param groupId идентификатор группы
     */
    handleGroupClick(categoryId, groupId) {
      this.searchValue = '';
      this.loadDocuments(categoryId, groupId);
    },
    /**
     * Загрузить список документов
     * @param categoryId идентификатор категории
     * @param groupId идентификатор группы
     */
    loadDocuments(categoryId, groupId) {
      this.$store.getters.axl
        .post('/docs/api/doc/list-by-group-and-category', {
          category_id: categoryId,
          group_id: groupId,
        })
        .then((response) => {
          this.products = response.data.products;
        });
    },
    /** Загрузить список категорий */
    loadCategories() {
      this.$store.getters.axl
        .get('/docs/api/doc/list-categories')
        .then((response) => {
          this.categories = response.data.categories;
        });
    },
    /**
     * Открыть урлу
     * @param product продукт
     */
    openUrl(product) {
      window.open(product.url, '_blank');
    },
  },
  destroyed() {
    this.$store.dispatch('SetSubmenu', '');
  },
  mounted() {
    this.loadCategories();
    this.$store.dispatch('SetTitle', 'Информация');
  },
};
